import { DateTimeRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import Link from '@/components/UI/Link';
import type { TanStackColumns } from '@/components/UI/Table/TableComponent.model';
import type { StudyCode } from '@/model/StudyCode.model';
import { web as webRoute } from '@/support/route';

export const generateStudyCodeColumns = (): TanStackColumns<StudyCode> => [
  {
    id: 'id',
    accessorKey: 'id',
    size: 50,
    isVisible: false,
    enableSorting: true,
  },
  {
    id: 'title',
    header: 'Title',
    cell: ({ row: { original } }: { row: { original: StudyCode } }) => (
      <>
        <div className="flex items-center pointer">
          <Link
            className="link w-100"
            to={webRoute('team.studies.study_codes.edit', { studyCodeApiId: original.api_id })}
          >
            {original.title}
          </Link>
        </div>
      </>
    ),
    isVisible: true,
    enableSorting: true,
    accessorKey: 'title',
  },
  {
    id: 'code',
    isVisible: true,
    header: 'Code',
    enableSorting: false,
    cell: ({
      row: {
        original: { composites },
      },
    }: {
      row: { original: StudyCode };
    }) =>
      composites
        ?.reduce<Array<string | number>>((acc, comp) => {
          acc[comp.order - 1] = comp.value;
          return acc;
        }, Array(composites.length).fill(''))
        .join(''),
  },
  {
    id: 'created_at',
    header: 'Created',
    isVisible: true,
    accessorKey: 'created_at',
    cell: ({
      row: {
        original: { created_at },
      },
    }: {
      row: { original: StudyCode };
    }) => <DateTimeRenderer value={created_at} />,
  },
  {
    id: 'updated_at',
    header: 'Updated',
    isVisible: true,
    accessorKey: 'updated_at',
    cell: ({
      row: {
        original: { updated_at },
      },
    }: {
      row: { original: StudyCode };
    }) => <DateTimeRenderer value={updated_at} />,
  },
];
